<template>
  <div class="create">
    <form
      class="compose"
      @submit.prevent="handleSubmit"
    >
      <input
        v-model="title"
        type="text"
        placeholder="subject"
        required
      >
      <textarea
        v-model="message"
        placeholder="message content"
        required
      />
      <button>Send message</button>
    </form>
  </div>
</template>

<script>
import { inject, ref } from 'vue'
import { db, serverTimestamp, addDoc, collection } from '@/firebase/config'

export default {
  props: ['messager'],
  setup (props, context) {
    const title = ref('')
    const message = ref('')
    const currentUser = inject('currentUser')

    const handleSubmit = async () => {
      const post = {
        title: title.value,
        message: message.value,
        receiver: props.messager.state.user.displayName,
        sender: currentUser.state.user.displayName,
        role: currentUser.state.role,
        grade: currentUser.state.grade,
        createdAt: serverTimestamp()
      }

      await addDoc(collection(db, '/schools/inspire-schools/' +
      currentUser.state.grade + '/messages/' + currentUser.state.role), post)
      context.emit('messagesent')
    }

    return { message, title, handleSubmit }
  }
}
</script>

<style scoped>
  .compose {
    max-width: 480px;
    margin: 0 auto;
    text-align: left;
    background: transparent;
  }
  input, textarea {
    display: block;
    margin: 10px 0;
    width: 100%;
    box-sizing: border-box;
    padding: 10px;
    border: 1px solid #eee;
    border-radius: 25px;
  }
  textarea {
    height: 160px;
  }
  .compose button {
    display: block;
    margin-top: 30px;
    background: #ff8800;
    color: white;
    border: none;
    border-radius: 25px;
    padding: 8px 16px;
    font-size: 18px
  }
</style>
